import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import "../index.css"

import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import { Dialog } from "primereact/dialog";
import { Tooltip } from "primereact/tooltip";
import { ConfirmDialog } from 'primereact/confirmdialog';

// Inputs
import { Button, CalendarField, CheckboxField, TextInputField, DropDownField, AutoCompleteField } from '../../../helpers'

// common components
import Loading from "../../../common/Loading"
import BillingAddressCards from "../../../common/BillingAddressCards"
import ShippingAddressCards from "../../../common/ShippingAddressCards"
import ReplacementItems from '../../../common/ReplacementItems'
import DispatchNoteItems from '../../../common/DispatchNoteItems'
import ReplaceBuyerReqItems from '../../../common/ReplaceBuyerReqItems'
import RenameBuyerInvoiceItems from '../../../common/RenameBuyerInvoiceItems'

// Child Components
import DispatchNote from './DispatchNoteList'

// apis
import { insertBuyerInvoice } from '../../../services/api/buyerInvoice'
import { searchUserRoles } from '../../../services/api/user';

// Redux
import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { fetchBuyerPOs } from '../../../services/redux/reducers/buyerPO/buyerPO'

// utils
import { validateInputs, round, calculateBuyerInvoice, sortArrayOfObjectsInAlphabeticalOrder, logisticHSNOptions } from '../../../utils'

// constants
import { DECIMAL_LIMIT } from '../../../constants'

// Validation
import { buyerInvoiceDetailSchema } from '../../../validation/buyerInvoiceValidation'


const TCSRateOptions = [
    { label: "0", value: 0 },
    { label: "0.1", value: 0.1 },
    { label: "2", value: 2 }
]

const biofuelActivityTypes = [
    { label: "CONTRACT MANUFACTURING", value: "CONTRACT MANUFACTURING" },
    { label: "MANUFACTURING", value: "MANUFACTURING" },
    { label: "TRADING", value: "TRADING" }
]

const CreateInvoice = (props) => {
    const { selectedBuyerPODispatchNotes, dispatchNoteItems, buyerCompanyBillAddrs, buyerCompanyPMBillAddrs, buyerCompanyBranchShipAddrs, userId, selectedBuyerPOs } = props
   
    const [selectedInvoiceDispatchNotesIds, setSelectedInvoiceDispatchNotesIds] = useState([])
    const [reqWiseGroupedDispatchNoteItems, setReqWiseGroupedDispatchNoteItems] = useState({})
    let [buyerReqWiseDispatchNoteItems, setBuyerReqWiseDispatchNoteItems] = useState([])
    const [poItemWiseGroupedDispatchNoteItemsMap, setPOItemWiseGroupedDispatchNoteItemsMap] = useState({})
    let [buyerPOItemWiseDispatchNoteItems, setBuyerPOItemWiseDispatchNoteItems] = useState([])
    const [selectedBuyerBillAddrId, setSelectedBuyerBillAddrId] = useState(null)
    const [selectedBuyerShipAddrId, setSelectedBuyerShipAddrId] = useState(null)
    const [isReplaceItemsVisible, setIsReplaceItemsVisible] = useState(false)
    const [buyerEmailId, setBuyerEmailId] = useState("")
    const [buyerPhoneNumber, setBuyerPhoneNumber] = useState("")
    const [buyerPODate, setBuyerPODate] = useState(null)
    const [buyerPONumbers, setBuyerPONumbers] = useState([])
    const [isReplaceItems, setIsReplaceItems] = useState(false)
    const [replaceBuyerReqItems, setReplaceBuyerReqItems] = useState([])
    const [selectedReplaceBuyerReqItems, setSelectedReplaceBuyerReqItems] = useState([])
    const [selectedReplaceBuyerReqItemIds, setSelectedReplaceBuyerReqItemIds] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [formErrors, setFormErrors] = useState({})
    const [companySupplyTypes, setCompanySupplyTypes] = useState([])
    const [supplyType, setSupplyType] = useState(null)
    const [logisticsHSNCode, setLogisticsHSNCode] = useState(null)
    const [searchedLogisticsHSNCodes, setSearchedLogisticsHSNCodes] = useState([])
    const [logisticAmount, setLogisticAmount] = useState(0)
    const [totalBuyerPOLogisticAmount, setTotalBuyerPOLogisticAmount] = useState(0)
    const [buyerCompanyUsers, setBuyerCompanyUsers] = useState([])
    const [searchedBuyerCompanyUsers, setSearchedBuyerCompanyUsers] = useState([])
    const [vehicleNo, setVehicleNo] = useState(null)
    const [recipientUser, setRecipientUser] = useState(null)
    const [showRecipientUserInput, setShowRecipientUserInput] = useState(false)
    const [buyerCompany, setBuyerCompany] = useState({})
    const [isLogisticsDeliveryAtActuals, setIsLogisticsDeliveryAtActuals] = useState(false)
    const [visibleRenameBuyerInvoiceItems, setVisibleRenameBuyerInvoiceItems] = useState(false)
    const [visibleConfirmPreviewInvoiceVisible, setVisibleConfirmPreviewInvoiceVisible] = useState(false)
    const [newBuyerInvoiceData, setNewBuyerInvoiceData] = useState({})
    const [suppliedToExporter, setSuppliedToExporter] = useState(false)
    const [TCSRate, setTCSRate] = useState(0)
    const [biofuelActivityType, setBiofuelActivityType] = useState("")
    
    const dispatch = useDispatch()

    const searchParams = useSelector(state => state.buyerPOData.searchParams)

    useEffect(() => {
        if (props.buyerCompanyBillAddrs.length === 1) {
            setSelectedBuyerBillAddrId(props.buyerCompanyBillAddrs[0].billAddrId)
        }

        if (props.buyerCompanyBranchShipAddrs.length === 1) {
            setSelectedBuyerShipAddrId(props.buyerCompanyBranchShipAddrs[0].shipAddrId)
        }

        if(props.selectedBuyerPOs && props.selectedBuyerPOs.length > 0){
            let buyerCompany = {
                companyId: props.selectedBuyerPOs[0].companyId,
                tags: props.selectedBuyerPOs[0]["companies.tags"]
            }
            setBuyerCompany(buyerCompany)

            const  buyerCompanyUserSearchParams = { 
                companyIds: [props.selectedBuyerPOs[0]?.companyId], 
                statusId: 1, 
                include: [{ model: "user", attributes: ["firstName", "lastName", "emailId", "phoneNumber"] }], 
                paginator: false
            }
            
            getBuyerCompanyUsersData(buyerCompanyUserSearchParams)
        }

        if(props.companySupplyTypes && props.companySupplyTypes?.length > 0){
            let relatedCompanySupplyType = []
            props.companySupplyTypes.map(eachSupplyType => {
                if(eachSupplyType.supplyType === "B2B" || eachSupplyType.supplyType === "B2C" || eachSupplyType.supplyType === "SEZWP" || eachSupplyType.supplyType === "SEZWOP"){
                    if(eachSupplyType.supplyType === "B2B"){
                        setSupplyType(eachSupplyType.supplyTypeId)
                    }
                    relatedCompanySupplyType.push(eachSupplyType)
                }
            })
            setCompanySupplyTypes(relatedCompanySupplyType)
        }

    }, [])

    useEffect(() => {
        let relatedRecipientUser = null
        if (selectedBuyerPODispatchNotes.length > 0) {
            let relatedDispatchNote = selectedBuyerPODispatchNotes.find(eachDispatchNote => selectedInvoiceDispatchNotesIds.includes(eachDispatchNote.dispatchNoteId))
            if (relatedDispatchNote) {
                if (relatedDispatchNote.recipientUserId) {
                    relatedRecipientUser = buyerCompanyUsers.find(eachUser => eachUser.userId === relatedDispatchNote.recipientUserId)
                    if (relatedRecipientUser) {
                        setRecipientUser(relatedRecipientUser)
                        setShowRecipientUserInput(true)
                    }
                }
                if (relatedDispatchNote.vehicleNo) {
                    setVehicleNo(relatedDispatchNote.vehicleNo)
                }
            }
        }

        if (!relatedRecipientUser) {
            let relatedDispatchSellerPO = props.selectedBuyerPOs.find(eachDispatchNote => eachDispatchNote?.buyerPO?.recipientUserId)
            if (relatedDispatchSellerPO) {
                let relatedUser = buyerCompanyUsers.find(eachUser => eachUser.userId === relatedDispatchSellerPO?.buyerPO?.recipientUserId)
                if (relatedUser) {
                    setRecipientUser(relatedUser)
                    setShowRecipientUserInput(true)
                }
            }
        }

    }, [selectedInvoiceDispatchNotesIds])

    const showBiofuelActivityType = useMemo(() => {
        const selectedInvoiceDispatchNotes = selectedBuyerPODispatchNotes.filter(eachDispatchNote => selectedInvoiceDispatchNotesIds.includes(eachDispatchNote.dispatchNoteId))
        let allCategoryIds = []
        selectedInvoiceDispatchNotes.forEach(eachSelectedInvoiceDispatchNote => {
            let relatedDispatchNoteItems = dispatchNoteItems.filter(eachDispatchNoteItem => eachDispatchNoteItem.dispatchNoteId === eachSelectedInvoiceDispatchNote.dispatchNoteId)
            relatedDispatchNoteItems.forEach(eachDispatchNoteItem => allCategoryIds.push(eachDispatchNoteItem.categoryId))
        })
        return allCategoryIds.includes(4)
    }, [selectedInvoiceDispatchNotesIds])


    const handleAllDispatchCheckBox = (e) => {
        const dispatchNoteIds = selectedBuyerPODispatchNotes.map(eachDispatchNote => eachDispatchNote.dispatchNoteId)
        if (e.checked) {
            setSelectedInvoiceDispatchNotesIds(dispatchNoteIds)

            let selectedBuyerPOIds = []
            let totalDispatchLogisticAmount = selectedBuyerPODispatchNotes.reduce((total, eachDispatchNote) => {
                return total + eachDispatchNote.logisticAmount
            },0)

            let totalBuyerPOLogisticAmount = 0
            let isLogisticOptionDeliveryAtActuals = false

            let reqWiseDispatchNoteItems = {}
            let relatedClientPONums = []
            let latestBuyerPODate = null
            dispatchNoteItems.map(eachDispatchNoteItem => {
                if (!reqWiseDispatchNoteItems[eachDispatchNoteItem.buyerReqItemId]) {
                    reqWiseDispatchNoteItems[eachDispatchNoteItem.buyerReqItemId] = [];
                }
                
                let relatedBuyerReqDispatchNoteItem = buyerReqWiseDispatchNoteItems.find(eachBuyerReqItem => eachBuyerReqItem.buyerReqItemId === eachDispatchNoteItem.buyerReqItemId)
                if (!relatedBuyerReqDispatchNoteItem) {
                    eachDispatchNoteItem.totalQty = eachDispatchNoteItem.qty
                    eachDispatchNoteItem.totalAmount = round(eachDispatchNoteItem.qty * eachDispatchNoteItem.unitPrice)
                    buyerReqWiseDispatchNoteItems.push(JSON.parse(JSON.stringify(eachDispatchNoteItem)))
                } else {
                    relatedBuyerReqDispatchNoteItem.qty += eachDispatchNoteItem.qty
                    relatedBuyerReqDispatchNoteItem.totalQty += eachDispatchNoteItem.qty
                    relatedBuyerReqDispatchNoteItem.totalAmount += round(eachDispatchNoteItem.qty * eachDispatchNoteItem.unitPrice)
                }

                reqWiseDispatchNoteItems[eachDispatchNoteItem.buyerReqItemId].push(JSON.parse(JSON.stringify(eachDispatchNoteItem)))

                if(!selectedBuyerPOIds.includes(eachDispatchNoteItem.buyerPOId)){
                    let relatedSelectedBuyerPO = selectedBuyerPOs.find(eachBuyerPO => eachBuyerPO.buyerPOId === eachDispatchNoteItem.buyerPOId)
                    if(relatedSelectedBuyerPO){
                        selectedBuyerPOIds.push(eachDispatchNoteItem.buyerPOId)
                        totalBuyerPOLogisticAmount += relatedSelectedBuyerPO?.bPOLogisticsBeforeTax || 0
                        if (relatedSelectedBuyerPO.bPOlogisticsOption?.toLowerCase() === "delivery at actuals") {
                            isLogisticOptionDeliveryAtActuals = true
                        }

                        if (relatedSelectedBuyerPO.clientPONum && !relatedClientPONums.includes(relatedSelectedBuyerPO.clientPONum)) {
                            relatedClientPONums.push(relatedSelectedBuyerPO.clientPONum)
                        }
            
                        if (relatedSelectedBuyerPO.poDocDate) {
                            if (!latestBuyerPODate) {
                                latestBuyerPODate = relatedSelectedBuyerPO.poDocDate
                            }
                            else {
                                if (relatedSelectedBuyerPO.poDocDate > latestBuyerPODate) {
                                    latestBuyerPODate = relatedSelectedBuyerPO.poDocDate
                                }
                            }
                        }
                    }
                }
            })

            if(isLogisticOptionDeliveryAtActuals){
                setIsLogisticsDeliveryAtActuals(true)
            }else{
                setIsLogisticsDeliveryAtActuals(false)
            }

            if(latestBuyerPODate){
                latestBuyerPODate = new Date(latestBuyerPODate)
            }

            setBuyerPODate(latestBuyerPODate)
            setBuyerPONumbers(relatedClientPONums)
            setLogisticAmount(totalDispatchLogisticAmount)
            setTotalBuyerPOLogisticAmount(totalBuyerPOLogisticAmount)
            setBuyerReqWiseDispatchNoteItems([...buyerReqWiseDispatchNoteItems])
            setReqWiseGroupedDispatchNoteItems(reqWiseDispatchNoteItems)
        } else {
            setSelectedInvoiceDispatchNotesIds([])
            setReqWiseGroupedDispatchNoteItems({})
            setBuyerReqWiseDispatchNoteItems([])
            setLogisticAmount(0)
            setTotalBuyerPOLogisticAmount(0)
            setIsLogisticsDeliveryAtActuals(false)
            setBuyerPODate(null)
            setBuyerPONumbers([])
        }
    }

    const handleAllDispatchCheckBoxBuyerPOItemLevel = (e) => {
        const dispatchNoteIds = selectedBuyerPODispatchNotes.map(eachDispatchNote => eachDispatchNote.dispatchNoteId)
        if (e.checked) {
            setSelectedInvoiceDispatchNotesIds(dispatchNoteIds)
    
            let selectedBuyerPOIds = []
            let totalDispatchLogisticAmount = selectedBuyerPODispatchNotes.reduce((total, eachDispatchNote) => {
                return total + eachDispatchNote.logisticAmount
            }, 0)
    
            let totalBuyerPOLogisticAmount = 0
            let isLogisticOptionDeliveryAtActuals = false
    
            let poItemWiseDispatchNoteItems = {}
            let relatedClientPONums = []
            let latestBuyerPODate = null
            
            dispatchNoteItems.map(eachDispatchNoteItem => {
                if (!poItemWiseDispatchNoteItems[eachDispatchNoteItem.buyerPOItemId]) {
                    poItemWiseDispatchNoteItems[eachDispatchNoteItem.buyerPOItemId] = []
                }
                
                let relatedBuyerPOItemDispatchNote = buyerPOItemWiseDispatchNoteItems.find(eachBuyerPOItem => eachBuyerPOItem.buyerPOItemId === eachDispatchNoteItem.buyerPOItemId)
                if (!relatedBuyerPOItemDispatchNote) {
                    eachDispatchNoteItem.totalQty = eachDispatchNoteItem.qty
                    eachDispatchNoteItem.totalAmount = round(eachDispatchNoteItem.qty * eachDispatchNoteItem.unitPrice)
                    buyerPOItemWiseDispatchNoteItems.push(JSON.parse(JSON.stringify(eachDispatchNoteItem)))
                } else {
                    relatedBuyerPOItemDispatchNote.qty += eachDispatchNoteItem.qty
                    relatedBuyerPOItemDispatchNote.totalQty += eachDispatchNoteItem.qty
                    relatedBuyerPOItemDispatchNote.totalAmount += round(eachDispatchNoteItem.qty * eachDispatchNoteItem.unitPrice)
                }
    
                poItemWiseDispatchNoteItems[eachDispatchNoteItem.buyerPOItemId].push(JSON.parse(JSON.stringify(eachDispatchNoteItem)))
    
                if (!selectedBuyerPOIds.includes(eachDispatchNoteItem.buyerPOId)) {
                    let relatedSelectedBuyerPO = selectedBuyerPOs.find(eachBuyerPO => eachBuyerPO.buyerPOId === eachDispatchNoteItem.buyerPOId)
                    if (relatedSelectedBuyerPO) {
                        selectedBuyerPOIds.push(eachDispatchNoteItem.buyerPOId)
                        totalBuyerPOLogisticAmount += relatedSelectedBuyerPO?.bPOLogisticsBeforeTax || 0
                        if (relatedSelectedBuyerPO.bPOlogisticsOption?.toLowerCase() === "delivery at actuals") {
                            isLogisticOptionDeliveryAtActuals = true
                        }
    
                        if (relatedSelectedBuyerPO.clientPONum && !relatedClientPONums.includes(relatedSelectedBuyerPO.clientPONum)) {
                            relatedClientPONums.push(relatedSelectedBuyerPO.clientPONum)
                        }
            
                        if (relatedSelectedBuyerPO.poDocDate) {
                            if (!latestBuyerPODate) {
                                latestBuyerPODate = relatedSelectedBuyerPO.poDocDate
                            }
                            else {
                                if (relatedSelectedBuyerPO.poDocDate > latestBuyerPODate) {
                                    latestBuyerPODate = relatedSelectedBuyerPO.poDocDate
                                }
                            }
                        }
                    }
                }
            })
    
            if (isLogisticOptionDeliveryAtActuals) {
                setIsLogisticsDeliveryAtActuals(true)
            } else {
                setIsLogisticsDeliveryAtActuals(false)
            }
    
            if (latestBuyerPODate) {
                latestBuyerPODate = new Date(latestBuyerPODate)
            }
    
            setBuyerPODate(latestBuyerPODate)
            setBuyerPONumbers(relatedClientPONums)
            setLogisticAmount(totalDispatchLogisticAmount)
            setTotalBuyerPOLogisticAmount(totalBuyerPOLogisticAmount)
            setBuyerPOItemWiseDispatchNoteItems([...buyerPOItemWiseDispatchNoteItems])
            setPOItemWiseGroupedDispatchNoteItemsMap(poItemWiseDispatchNoteItems)
        } else {
            setSelectedInvoiceDispatchNotesIds([])
            setPOItemWiseGroupedDispatchNoteItemsMap({})
            setBuyerPOItemWiseDispatchNoteItems([])
            setLogisticAmount(0)
            setTotalBuyerPOLogisticAmount(0)
            setIsLogisticsDeliveryAtActuals(false)
            setBuyerPODate(null)
            setBuyerPONumbers([])
        }
    }
    
    const handleSelectDispatchCheckBox = (selectedDispatchNoteId) => {
        let relatedClientPONums = []
        let latestBuyerPODate = null
        if (selectedInvoiceDispatchNotesIds.includes(selectedDispatchNoteId)) {
            const relatedDispatchNotesIds = selectedInvoiceDispatchNotesIds.filter(eachDispatchNoteId => eachDispatchNoteId !== selectedDispatchNoteId)
            setSelectedInvoiceDispatchNotesIds(relatedDispatchNotesIds)
            Object.keys(reqWiseGroupedDispatchNoteItems).map((buyerReqItemId, index) => {
                let dispatchNoteItems = reqWiseGroupedDispatchNoteItems[buyerReqItemId]
                const relatedDispatchNoteItems = dispatchNoteItems.filter(eachDispatchNoteItemId => eachDispatchNoteItemId.dispatchNoteId !== selectedDispatchNoteId)

                reqWiseGroupedDispatchNoteItems[buyerReqItemId] = relatedDispatchNoteItems

                if (relatedDispatchNoteItems.length === 0) {
                    delete reqWiseGroupedDispatchNoteItems[buyerReqItemId]
                }
            })

            let selectedBuyerPOIds = []
            let totalDispatchLogisticAmount = selectedBuyerPODispatchNotes.reduce((total, eachDispatchNote) => {
                if(relatedDispatchNotesIds.includes(eachDispatchNote.dispatchNoteId)){
                    return total + eachDispatchNote.logisticAmount
                }
            },0)

            let totalBuyerPOLogisticAmount = 0
            let isLogisticOptionDeliveryAtActuals = false
            dispatchNoteItems.map(eachDispatchNoteItem => {
                if (eachDispatchNoteItem.dispatchNoteId === selectedDispatchNoteId) {
                    let relatedBuyerReqDispatchNoteItem = buyerReqWiseDispatchNoteItems.find(eachBuyerReqItem => eachBuyerReqItem.buyerReqItemId === eachDispatchNoteItem.buyerReqItemId)
                    if(relatedBuyerReqDispatchNoteItem){
                        relatedBuyerReqDispatchNoteItem.qty -= eachDispatchNoteItem.qty
                        relatedBuyerReqDispatchNoteItem.totalQty -= eachDispatchNoteItem.qty
                        relatedBuyerReqDispatchNoteItem.totalAmount = round(eachDispatchNoteItem.qty * eachDispatchNoteItem.unitPrice)

                        if (relatedBuyerReqDispatchNoteItem.qty === 0) {
                            buyerReqWiseDispatchNoteItems = buyerReqWiseDispatchNoteItems.filter(eachDispatchNoteItem => eachDispatchNoteItem.dispatchNoteItemId !== relatedBuyerReqDispatchNoteItem.dispatchNoteItemId)
                            /*
                            const index = buyerReqWiseDispatchNoteItems.indexOf(relatedBuyerReqDispatchNoteItem)
                            if (index !== -1) {
                                buyerReqWiseDispatchNoteItems.splice(index, 1)
                            }
                            */
                        }
                    }
                }

                if(!selectedBuyerPOIds.includes(eachDispatchNoteItem.buyerPOId) && relatedDispatchNotesIds.includes(eachDispatchNoteItem.dispatchNoteId)){
                    let relatedSelectedBuyerPO = selectedBuyerPOs.find(eachBuyerPO => eachBuyerPO.buyerPOId === eachDispatchNoteItem.buyerPOId)
                    if(relatedSelectedBuyerPO){
                        selectedBuyerPOIds.push(eachDispatchNoteItem.buyerPOId)
                        totalBuyerPOLogisticAmount += relatedSelectedBuyerPO?.bPOLogisticsBeforeTax || 0

                        if (relatedSelectedBuyerPO.bPOlogisticsOption?.toLowerCase() === "delivery at actuals") {
                            isLogisticOptionDeliveryAtActuals = true
                        }

                        if (relatedSelectedBuyerPO.clientPONum && !relatedClientPONums.includes(relatedSelectedBuyerPO.clientPONum)) {
                            relatedClientPONums.push(relatedSelectedBuyerPO.clientPONum)
                        }
            
                        if (relatedSelectedBuyerPO.poDocDate) {
                            if (!latestBuyerPODate) {
                                latestBuyerPODate = relatedSelectedBuyerPO.poDocDate
                            }
                            else {
                                if (relatedSelectedBuyerPO.poDocDate > latestBuyerPODate) {
                                    latestBuyerPODate = relatedSelectedBuyerPO.poDocDate
                                }
                            }
                        }
                    }
                }
            })

            if(isLogisticOptionDeliveryAtActuals){
                setIsLogisticsDeliveryAtActuals(true)
            }else{
                setIsLogisticsDeliveryAtActuals(false)
            }
            
            setLogisticAmount(totalDispatchLogisticAmount)
            setTotalBuyerPOLogisticAmount(totalBuyerPOLogisticAmount)
            setBuyerReqWiseDispatchNoteItems([...buyerReqWiseDispatchNoteItems])
            setReqWiseGroupedDispatchNoteItems({ ...reqWiseGroupedDispatchNoteItems })
        } else {
            const relatedDispatchNotesIds = [...selectedInvoiceDispatchNotesIds, selectedDispatchNoteId]
            setSelectedInvoiceDispatchNotesIds(relatedDispatchNotesIds)

            let selectedBuyerPOIds = []
            let totalDispatchLogisticAmount = selectedBuyerPODispatchNotes.reduce((total, eachDispatchNote) => {
                if(relatedDispatchNotesIds.includes(eachDispatchNote.dispatchNoteId)){
                    return total + eachDispatchNote.logisticAmount
                }
            },0)

            let totalBuyerPOLogisticAmount = 0
            let isLogisticOptionDeliveryAtActuals = false
            dispatchNoteItems.map(eachDispatchNoteItem => {
                if (eachDispatchNoteItem.dispatchNoteId === selectedDispatchNoteId) {
                    if (!reqWiseGroupedDispatchNoteItems[eachDispatchNoteItem.buyerReqItemId]) {
                        reqWiseGroupedDispatchNoteItems[eachDispatchNoteItem.buyerReqItemId] = [];
                    }

                    let relatedBuyerReqDispatchNoteItem = buyerReqWiseDispatchNoteItems.find(eachBuyerReqItem => eachBuyerReqItem.buyerReqItemId === eachDispatchNoteItem.buyerReqItemId)
                    if(!relatedBuyerReqDispatchNoteItem){
                        eachDispatchNoteItem.totalQty = eachDispatchNoteItem.qty
                        eachDispatchNoteItem.totalAmount = round(eachDispatchNoteItem.qty * eachDispatchNoteItem.unitPrice, 4)
                        buyerReqWiseDispatchNoteItems.push(JSON.parse(JSON.stringify(eachDispatchNoteItem)))
                    }else{
                        relatedBuyerReqDispatchNoteItem.qty += eachDispatchNoteItem.qty
                        relatedBuyerReqDispatchNoteItem.totalQty += eachDispatchNoteItem.qty
                        relatedBuyerReqDispatchNoteItem.totalAmount = round(eachDispatchNoteItem.qty * eachDispatchNoteItem.unitPrice, 4)
                    }

                    if(!selectedBuyerPOIds.includes(eachDispatchNoteItem.buyerPOId) && relatedDispatchNotesIds.includes(eachDispatchNoteItem.dispatchNoteId)){
                        let relatedSelectedBuyerPO = selectedBuyerPOs.find(eachBuyerPO => eachBuyerPO.buyerPOId === eachDispatchNoteItem.buyerPOId)
                        if(relatedSelectedBuyerPO){
                            selectedBuyerPOIds.push(eachDispatchNoteItem.buyerPOId)
                            totalBuyerPOLogisticAmount += relatedSelectedBuyerPO?.bPOLogisticsBeforeTax || 0

                            if (relatedSelectedBuyerPO.bPOlogisticsOption?.toLowerCase() === "delivery at actuals") {
                                isLogisticOptionDeliveryAtActuals = true
                            }

                            if (relatedSelectedBuyerPO.clientPONum && !relatedClientPONums.includes(relatedSelectedBuyerPO.clientPONum)) {
                                relatedClientPONums.push(relatedSelectedBuyerPO.clientPONum)
                            }
                
                            if (relatedSelectedBuyerPO.poDocDate) {
                                if (!latestBuyerPODate) {
                                    latestBuyerPODate = relatedSelectedBuyerPO.poDocDate
                                }
                                else {
                                    if (relatedSelectedBuyerPO.poDocDate > latestBuyerPODate) {
                                        latestBuyerPODate = relatedSelectedBuyerPO.poDocDate
                                    }
                                }
                            }
                        }
                    }

                    reqWiseGroupedDispatchNoteItems[eachDispatchNoteItem.buyerReqItemId].push(JSON.parse(JSON.stringify(eachDispatchNoteItem)))
                }
            })

            if(isLogisticOptionDeliveryAtActuals){
                setIsLogisticsDeliveryAtActuals(true)
            }else{
                setIsLogisticsDeliveryAtActuals(false)
            }
            
            setLogisticAmount(totalDispatchLogisticAmount)
            setTotalBuyerPOLogisticAmount(totalBuyerPOLogisticAmount)
            setBuyerReqWiseDispatchNoteItems([...buyerReqWiseDispatchNoteItems])
            setReqWiseGroupedDispatchNoteItems({ ...reqWiseGroupedDispatchNoteItems })
        }

        if(latestBuyerPODate){
            latestBuyerPODate = new Date(latestBuyerPODate)
        }

        setBuyerPODate(latestBuyerPODate)
        setBuyerPONumbers(relatedClientPONums)
    }

    const handleSelectDispatchCheckBoxBuyerPOItemLevel = (selectedDispatchNoteId) => {
        let relatedClientPONums = []
        let latestBuyerPODate = null
        
        if (selectedInvoiceDispatchNotesIds.includes(selectedDispatchNoteId)) {
            const relatedDispatchNotesIds = selectedInvoiceDispatchNotesIds.filter(eachDispatchNoteId => eachDispatchNoteId !== selectedDispatchNoteId)
            setSelectedInvoiceDispatchNotesIds(relatedDispatchNotesIds)
    
            Object.keys(poItemWiseGroupedDispatchNoteItemsMap).map((buyerPOItemId) => {
                let dispatchNoteItems = poItemWiseGroupedDispatchNoteItemsMap[buyerPOItemId]
                const relatedDispatchNoteItems = dispatchNoteItems.filter(eachDispatchNoteItem => eachDispatchNoteItem.dispatchNoteId !== selectedDispatchNoteId)
                
                poItemWiseGroupedDispatchNoteItemsMap[buyerPOItemId] = relatedDispatchNoteItems
                
                if (relatedDispatchNoteItems.length === 0) {
                    delete poItemWiseGroupedDispatchNoteItemsMap[buyerPOItemId]
                }
            })
    
            let selectedBuyerPOIds = []
            let totalDispatchLogisticAmount = selectedBuyerPODispatchNotes.reduce((total, eachDispatchNote) => {
                if (relatedDispatchNotesIds.includes(eachDispatchNote.dispatchNoteId)) {
                    return total + eachDispatchNote.logisticAmount
                }
            }, 0)
    
            let totalBuyerPOLogisticAmount = 0
            let isLogisticOptionDeliveryAtActuals = false
            dispatchNoteItems.map(eachDispatchNoteItem => {
                if (eachDispatchNoteItem.dispatchNoteId === selectedDispatchNoteId) {
                    let relatedBuyerPOItemDispatchNote = buyerPOItemWiseDispatchNoteItems.find(eachBuyerPOItem => eachBuyerPOItem.buyerPOItemId === eachDispatchNoteItem.buyerPOItemId)
                    if (relatedBuyerPOItemDispatchNote) {
                        relatedBuyerPOItemDispatchNote.qty -= eachDispatchNoteItem.qty
                        relatedBuyerPOItemDispatchNote.totalQty -= eachDispatchNoteItem.qty
                        relatedBuyerPOItemDispatchNote.totalAmount = round(eachDispatchNoteItem.qty * eachDispatchNoteItem.unitPrice)
    
                        if (relatedBuyerPOItemDispatchNote.qty === 0) {
                            buyerPOItemWiseDispatchNoteItems = buyerPOItemWiseDispatchNoteItems.filter(eachDispatchNoteItem => eachDispatchNoteItem.dispatchNoteItemId !== relatedBuyerPOItemDispatchNote.dispatchNoteItemId)
                        }
                    }
                }
            })
    
            setLogisticAmount(totalDispatchLogisticAmount)
            setTotalBuyerPOLogisticAmount(totalBuyerPOLogisticAmount)
            setBuyerPOItemWiseDispatchNoteItems([...buyerPOItemWiseDispatchNoteItems])
            setPOItemWiseGroupedDispatchNoteItemsMap({ ...poItemWiseGroupedDispatchNoteItemsMap })
        } else {
            const relatedDispatchNotesIds = [...selectedInvoiceDispatchNotesIds, selectedDispatchNoteId]
            setSelectedInvoiceDispatchNotesIds(relatedDispatchNotesIds)
            
            let selectedBuyerPOIds = []
            let totalDispatchLogisticAmount = selectedBuyerPODispatchNotes.reduce((total, eachDispatchNote) => {
                if (relatedDispatchNotesIds.includes(eachDispatchNote.dispatchNoteId)) {
                    return total + eachDispatchNote.logisticAmount
                }
            }, 0)
    
            let totalBuyerPOLogisticAmount = 0
            let isLogisticOptionDeliveryAtActuals = false
            dispatchNoteItems.map(eachDispatchNoteItem => {
                if (eachDispatchNoteItem.dispatchNoteId === selectedDispatchNoteId) {
                    if (!poItemWiseGroupedDispatchNoteItemsMap[eachDispatchNoteItem.buyerPOItemId]) {
                        poItemWiseGroupedDispatchNoteItemsMap[eachDispatchNoteItem.buyerPOItemId] = []
                    }
                    let relatedBuyerPOItemDispatchNote = buyerPOItemWiseDispatchNoteItems.find(eachBuyerPOItem => eachBuyerPOItem.buyerPOItemId === eachDispatchNoteItem.buyerPOItemId)
                    if (!relatedBuyerPOItemDispatchNote) {
                        eachDispatchNoteItem.totalQty = eachDispatchNoteItem.qty
                        eachDispatchNoteItem.totalAmount = round(eachDispatchNoteItem.qty * eachDispatchNoteItem.unitPrice, 4)
                        buyerPOItemWiseDispatchNoteItems.push(JSON.parse(JSON.stringify(eachDispatchNoteItem)))
                    } else {
                        relatedBuyerPOItemDispatchNote.qty += eachDispatchNoteItem.qty
                        relatedBuyerPOItemDispatchNote.totalQty += eachDispatchNoteItem.qty
                        relatedBuyerPOItemDispatchNote.totalAmount = round(eachDispatchNoteItem.qty * eachDispatchNoteItem.unitPrice, 4)
                    }
    
                    poItemWiseGroupedDispatchNoteItemsMap[eachDispatchNoteItem.buyerPOItemId].push(JSON.parse(JSON.stringify(eachDispatchNoteItem)))
                }
            })
            
            setLogisticAmount(totalDispatchLogisticAmount)
            setTotalBuyerPOLogisticAmount(totalBuyerPOLogisticAmount)
            setBuyerPOItemWiseDispatchNoteItems([...buyerPOItemWiseDispatchNoteItems])
            setPOItemWiseGroupedDispatchNoteItemsMap({ ...poItemWiseGroupedDispatchNoteItemsMap })
        }
    
        if (latestBuyerPODate) {
            latestBuyerPODate = new Date(latestBuyerPODate)
        }
    
        setBuyerPODate(latestBuyerPODate)
        setBuyerPONumbers(relatedClientPONums)
    }
    
    const getBuyerCompanyUsersData = async (searchParams) => {
        setIsLoading(true)
        const buyerCompanyUsersDataResponse = await searchUserRoles({...searchParams})
        // console.log("buyerCompanyUsersData-response", buyerCompanyUsersDataResponse)
        setIsLoading(false)
        if(buyerCompanyUsersDataResponse.failure){
            return dispatch(raiseToast({severity:'error', detail: buyerCompanyUsersDataResponse.data.error, life: 3000}))
        }
        else{
            let usersList = buyerCompanyUsersDataResponse.data.data.map(eachUser => {
                return {
                    userId: eachUser.userId,
                    fullName: eachUser["user.firstName"] + " " + (eachUser?.["user.lastName"] ? eachUser["user.lastName"] : ''),
                    phoneNumber: eachUser["user.phoneNumber"]
                }
            })
            usersList = _.uniqBy(usersList, 'userId');
            usersList = sortArrayOfObjectsInAlphabeticalOrder(usersList, 'fullName')
            
            setBuyerCompanyUsers(usersList)

        }
    }

    const onSubmitCreateInvoice = async () => {
        
        if(selectedInvoiceDispatchNotesIds.length === 0){
            return dispatch(raiseToast({severity:'warn', detail: "Please select dispatch notes", life: 3000}))
        }

        if (buyerCompany.tags?.shouldEnforceDispatch){
            if (selectedBuyerPODispatchNotes.length !== selectedInvoiceDispatchNotesIds.length){
                return dispatch(raiseToast({severity:'warn', detail: "Please select all the dispatch notes", life: 3000}))
            }
        }

        if(!selectedBuyerShipAddrId){
            return dispatch(raiseToast({severity:'warn', detail: "Please select shipping address", life: 3000}))
        }

        if(!selectedBuyerBillAddrId){
            return dispatch(raiseToast({severity:'warn', detail: "Please select billing address", life: 3000}))
        }

        if(showBiofuelActivityType && !biofuelActivityType){
            return dispatch(raiseToast({severity:'warn', detail: "Please select biofuels activity type" }))
        }

        let trimmedVehicleNo = vehicleNo ? vehicleNo.trim() : null

        if (trimmedVehicleNo === '') {
            trimmedVehicleNo = null;
        }

        if (trimmedVehicleNo && (trimmedVehicleNo.length < 9 || trimmedVehicleNo.length > 15)) {
            return dispatch(raiseToast({ severity: 'warn', detail: 'Vehicle number length should be between 9 to 15', life: 3000 }));
        }

        let selectedDispatchNoteBuyerPOIds = _.uniq(_.map(dispatchNoteItems, 'buyerPOId'))
        let relatedBuyerPO = selectedBuyerPOs.find(eachBuyerPO => selectedDispatchNoteBuyerPOIds.includes(eachBuyerPO.buyerPOId))

        let pmBillAddrId = ''
        let pmBillAddrStateId = 27 // By defualt it's maharastra
        if(relatedBuyerPO){
            pmBillAddrId = relatedBuyerPO.pmBillAddrId

            let relatedPMBillAddr = buyerCompanyPMBillAddrs.find(eachBillAddr => eachBillAddr.billAddrId === relatedBuyerPO?.pmBillAddrId)
            if (relatedPMBillAddr) {
                pmBillAddrStateId = relatedPMBillAddr.stateId
            }
        }

        if(!pmBillAddrId){
            return dispatch(raiseToast({severity:'warn', detail: "Buyer po doesn't have PM Bill Address", life: 3000}))
        }

        let relatedDispatchNoteItems = []
        let totalLogisticsBeforeTax = 0
        selectedInvoiceDispatchNotesIds?.map(eachInvoiceDispatchNoteId => {
            // const relatedDispatchNoteItem = dispatchNoteItems?.find(eachDispatchNoteItem => eachDispatchNoteItem?.dispatchNoteId === eachInvoiceDispatchNoteId)
            // if (relatedDispatchNoteItem){
            //     relatedDispatchNoteItems.push(relatedDispatchNoteItem)
            // }
            let relatedDispatchNote = selectedBuyerPODispatchNotes?.find(eachDispatchNote => eachDispatchNote?.dispatchNoteId === eachInvoiceDispatchNoteId)
            if (relatedDispatchNote?.logisticAmount){
                totalLogisticsBeforeTax += parseFloat(relatedDispatchNote?.logisticAmount)
            }
            dispatchNoteItems?.map(eachDispatchNoteItem => {
                if(eachDispatchNoteItem.dispatchNoteId === eachInvoiceDispatchNoteId){
                    relatedDispatchNoteItems.push(eachDispatchNoteItem)
                }
            })
        })
        relatedDispatchNoteItems = _.sortBy(relatedDispatchNoteItems, 'buyerPOItemId')

        const selectedInvoiceDispatchNotes = selectedBuyerPODispatchNotes.filter(eachDispatchNote => selectedInvoiceDispatchNotesIds.includes(eachDispatchNote.dispatchNoteId))

        const isUOMUnavailable = relatedDispatchNoteItems.some(eachDispatchSellerPOItem => !eachDispatchSellerPOItem.UOM)

        if(isUOMUnavailable){
            return dispatch(raiseToast({ severity: 'error', detail: 'UOM is missing! please contact tech team', life: 3000 }))
        }

        const relatedBuyerBillAddr = buyerCompanyBillAddrs.find(eachAddr => eachAddr.billAddrId === selectedBuyerBillAddrId)
        const pmCompanyBillAddrDetails = buyerCompanyPMBillAddrs.find(eachBillAddr => eachBillAddr.billAddrId === relatedBuyerPO?.pmBillAddrId)

        let isIGST = relatedBuyerBillAddr?.stateId === pmCompanyBillAddrDetails?.stateId ? false : true

        if(pmCompanyBillAddrDetails.gstinCode && !["URP", "URD"].includes(pmCompanyBillAddrDetails.gstinCode) && relatedBuyerBillAddr.gstinCode && !["URP", "URD"].includes(relatedBuyerBillAddr.gstinCode)){
            isIGST = parseInt(pmCompanyBillAddrDetails.gstinCode.slice(0, 2)) !== parseInt(relatedBuyerBillAddr.gstinCode.slice(0, 2))
        }

        let buyerInvoiceData = {
            //isURP: buyerInvoiceData.isURP,
            supplyTypeId: supplyType,
            companyId: selectedBuyerPODispatchNotes[0].companyId,
            pmCompanyId: selectedBuyerPODispatchNotes[0].pmCompanyId,
            branchId: selectedBuyerPODispatchNotes[0].branchId,
            pmBranchId: selectedBuyerPODispatchNotes[0].pmBranchId,
            billAddrId: selectedBuyerBillAddrId,
            shipAddrId: selectedBuyerShipAddrId,
            buyerEmailId: buyerEmailId,
            buyerPhoneNumber: buyerPhoneNumber,
            buyerPODate: buyerPODate,
            buyerPONumbers: buyerPONumbers,
            pmBillAddrStateId: pmBillAddrStateId,
            pmBillAddrId: pmBillAddrId, //selectedBuyerPODispatchNotes[0]?.pmBillAddrId,
            userId: relatedBuyerPO?.userId,
            logisticsHSNCode: logisticsHSNCode ? parseInt(logisticsHSNCode.value) : null,
            //paymentTerms: dispatchNotes[0].paymentTerms,
            logisticsBeforeTax: totalLogisticsBeforeTax,
            //logisticsGSTRate: dispatchNotes[0].logisticsGSTRate,
            //logisticsWithTax: dispatchNotes[0].logisticsWithTax,
            //totalAmountBeforeTax: dispatchNotes[0].totalAmountBeforeTax,
            //totalInvTax: dispatchNotes[0].totalInvTax,
            //totalAmountWithTax: dispatchNotes[0].totalAmountWithTax,
            //totalInvAmount: dispatchNotes[0].totalInvAmount,
            //currency: dispatchNotes[0].currency,
            //currencyRate: dispatchNotes[0].currencyRate,
            GSTType: isIGST ? "I" : "CS",
            createdBy: userId,
            updatedBy: userId,
            approvedAt: new Date(),
            vehicleNo: trimmedVehicleNo,
            recipientUserId: recipientUser ? recipientUser?.userId : null,
            suppliedToExporter: suppliedToExporter,
            TCSRate: TCSRate,
            biofuelActivityType: biofuelActivityType
        }

        // const buyerReqItemIds = _.uniqBy(relatedDispatchNoteItems, 'buyerReqItemId').map(obj => obj.buyerReqItemId)
    
        // let buyerInvoiceItems = []
        // buyerReqItemIds.map(eachBuyerReqItemId => {
        //     const filteredDispatchNoteItems = relatedDispatchNoteItems?.filter(eachDispatchNoteItem => eachDispatchNoteItem.buyerReqItemId === eachBuyerReqItemId)
        //     //const relatedDispatchNote = selectedBuyerPODispatchNotes?.find(eachDispatchNote => eachDispatchNote?.dispatchNoteId === relatedDispatchNoteItem?.dispatchNoteId)
    
        //     let totalInvoiceQty = 0
        //     filteredDispatchNoteItems.map(eachDispatchNoteItem => {
        //         totalInvoiceQty += parseFloat(eachDispatchNoteItem.qty)
        //     })

        //     let newBuyerInvoiceItem = {
        //         buyerReqId: filteredDispatchNoteItems[0]?.buyerReqId,
        //         buyerReqItemId: filteredDispatchNoteItems[0]?.buyerReqItemId,
        //         materialId: filteredDispatchNoteItems[0]?.materialId,
        //         qty: totalInvoiceQty,
        //         listPrice: filteredDispatchNoteItems[0]?.listPrice,
        //         unitPrice: filteredDispatchNoteItems[0]?.unitPrice,
        //         HSNCode: filteredDispatchNoteItems[0]?.HSNCode,
        //         GSTRate: filteredDispatchNoteItems[0]?.GSTRate,
        //         buyerRateContractId: filteredDispatchNoteItems[0]?.buyerRateContractId,
        //         createdBy: userId,
        //         updatedBy: userId,
        //     }

        //     if(buyerInvoiceData.supplyTypeId === 4){
        //         newBuyerInvoiceItem.GSTRate = 0
        //     }

        //     // relatedDispatchNoteItems.map(eachDispatchNoteItem => newBuyerInvoiceItem.qty += eachDispatchNoteItem.qty)

        //     buyerInvoiceItems.push(newBuyerInvoiceItem)
        // })

        let groupingItemId = "buyerReqItemId"
        if (selectedInvoiceDispatchNotes[0].itemsGroupedBy){
            groupingItemId = selectedInvoiceDispatchNotes[0].itemsGroupedBy
        }

        const groupingItemIds = _.uniqBy(relatedDispatchNoteItems, groupingItemId).map(obj => obj[groupingItemId])

        let buyerInvoiceItems = []
        groupingItemIds.map(eachGroupingItemId => {
            const filteredDispatchNoteItems = relatedDispatchNoteItems?.filter(eachDispatchNoteItem => eachDispatchNoteItem[groupingItemId] === eachGroupingItemId)
            //const relatedDispatchNote = selectedBuyerPODispatchNotes?.find(eachDispatchNote => eachDispatchNote?.dispatchNoteId === relatedDispatchNoteItem?.dispatchNoteId)
    
            let totalInvoiceQty = 0
            filteredDispatchNoteItems.map(eachDispatchNoteItem => {
                totalInvoiceQty += parseFloat(eachDispatchNoteItem.qty)
            })

            let newBuyerInvoiceItem = {
                buyerReqId: filteredDispatchNoteItems[0]?.buyerReqId,
                buyerReqItemId: filteredDispatchNoteItems[0]?.buyerReqItemId,
                materialId: filteredDispatchNoteItems[0]?.materialId,
                qty: totalInvoiceQty,
                listPrice: filteredDispatchNoteItems[0]?.listPrice,
                unitPrice: filteredDispatchNoteItems[0]?.unitPrice,
                HSNCode: filteredDispatchNoteItems[0]?.HSNCode,
                GSTRate: filteredDispatchNoteItems[0]?.GSTRate,
                buyerRateContractId: filteredDispatchNoteItems[0]?.buyerRateContractId,
                createdBy: userId,
                updatedBy: userId,
            }

            if (buyerInvoiceData.suppliedToExporter) {
                newBuyerInvoiceItem.GSTRate = 0.1
            }

            if(buyerInvoiceData.supplyTypeId === 4){
                newBuyerInvoiceItem.GSTRate = 0
            }

            if(groupingItemId === "buyerPOItemId"){
                newBuyerInvoiceItem.buyerPOItemId = eachGroupingItemId
            }

            // relatedDispatchNoteItems.map(eachDispatchNoteItem => newBuyerInvoiceItem.qty += eachDispatchNoteItem.qty)

            buyerInvoiceItems.push(newBuyerInvoiceItem)
        })

        if (buyerInvoiceData.suppliedToExporter) {
            buyerInvoiceData.logisticsGSTRate = 0.1
        }

        if(buyerInvoiceData.supplyTypeId === 4){
            buyerInvoiceData.logisticsGSTRate = 0
        }

        let calculateBuyerInvoiceResponse = calculateBuyerInvoice(buyerInvoiceData, buyerInvoiceItems)
    
        buyerInvoiceData = calculateBuyerInvoiceResponse.buyerInvoice
        buyerInvoiceItems = calculateBuyerInvoiceResponse.buyerInvoiceItems
        
        buyerInvoiceItems = buyerInvoiceItems?.map(eachBuyerInvoiceItem => {
            let itemAmountBeforeTax = eachBuyerInvoiceItem?.qty * eachBuyerInvoiceItem?.unitPrice
            return {
                ...eachBuyerInvoiceItem, 
                itemAmountBeforeTax : parseFloat(itemAmountBeforeTax),
                itemAmountWithTax : parseFloat(itemAmountBeforeTax) + parseFloat(itemAmountBeforeTax) * eachBuyerInvoiceItem?.GSTRate * 0.01

            }
        })
        let replaceBuyerReqItems = buyerReqWiseDispatchNoteItems.filter(eachDispatchNoteItem => eachDispatchNoteItem.isReplaced)
        let replacementItems = []

        replaceBuyerReqItems.map(eachDispatchNoteItem => {
            
            let replacementBuyerReqObj = {
                companyId : selectedBuyerPODispatchNotes[0].companyId,
                HSNCode : eachDispatchNoteItem.HSNCode,
                replaceByName: eachDispatchNoteItem.companyProdName, //eachDispatchNoteItem.productName,
                replaceByDesc: eachDispatchNoteItem.companyProdSpec, //eachDispatchNoteItem.productSpecification,
                persistent :  false,
                createdBy :  userId,
                unitPrice: eachDispatchNoteItem.unitPrice,
                UOM: eachDispatchNoteItem?.UOM
            }

            let replacedBuyerReqItems = {}
            eachDispatchNoteItem.replacedBuyerReqItems.map(eachBuyerReqItem => {
                if(replacedBuyerReqItems.hasOwnProperty(eachBuyerReqItem.materialId)){
                    replacedBuyerReqItems[eachBuyerReqItem.materialId] += round(parseFloat(eachBuyerReqItem.qty)/parseFloat(eachDispatchNoteItem.qty),4)
                }else{
                    replacedBuyerReqItems[eachBuyerReqItem.materialId] = round(eachBuyerReqItem.qty/eachDispatchNoteItem.qty,4)
                }
            })

            replacementBuyerReqObj.toReplace = replacedBuyerReqItems

            let docItemReplacementLog = {
                qtyReplaced: eachDispatchNoteItem.qty,
                createdBy: userId,
                GSTRate: eachDispatchNoteItem.GSTRate,
                unitPrice: eachDispatchNoteItem.unitPrice
            }

            replacementBuyerReqObj.docItemReplacementLog = docItemReplacementLog
            replacementItems.push(replacementBuyerReqObj)
        })
        
        let dispatchNoteIds = selectedInvoiceDispatchNotesIds
        let dispatchNoteDocNo = selectedBuyerPODispatchNotes[0].docNo
        let dispatchNoteFileNo = selectedBuyerPODispatchNotes[0].fileNo
        let allDispatchNoteItems = []

        let newDeliveryChallan = []
        selectedBuyerPODispatchNotes.map(eachDispatchNote => {
            if(selectedInvoiceDispatchNotesIds.includes(eachDispatchNote.dispatchNoteId) && !eachDispatchNote.deliveryChallan){
                let relatedDispatchNoteItem = dispatchNoteItems.find(eachDispatchNoteItem => eachDispatchNoteItem.dispatchNoteId === eachDispatchNote.dispatchNoteId)
                let relatedBuyerPO = selectedBuyerPOs.find(eachBuyerPO => eachBuyerPO.buyerPOId === relatedDispatchNoteItem.buyerPOId)

                if(!relatedBuyerPO){
                    return dispatch(raiseToast({severity:'warn', detail: "Buyer po not found for one of the dispatch note item", life: 3000}))
                }
                let deliveryChallanObj = {
                    dispatchNoteId: eachDispatchNote.dispatchNoteId,
                    createdAt: new Date(),
                    createdBy: userId,
                    docNo: relatedBuyerPO.docNo,
                    fileNo: relatedBuyerPO.fileNo,
                    pmBillAddrStateId: pmBillAddrStateId,
                    billAddrId: selectedBuyerBillAddrId,
                    shipAddrId: selectedBuyerShipAddrId,
                    pmBillAddrId: pmBillAddrId,
                }

                newDeliveryChallan.push(deliveryChallanObj)
            }
        })

        const buyerInvoiceDetailsValidationResponse = await validateInputs(buyerInvoiceDetailSchema, buyerInvoiceData)
        // console.log("buyerInvoiceDetailsValidation-response", buyerInvoiceDetailsValidationResponse)

        if (buyerInvoiceDetailsValidationResponse) {
            if (buyerInvoiceDetailsValidationResponse.error) {
                setFormErrors(buyerInvoiceDetailsValidationResponse.error)
            }
            else {
                setFormErrors({})
                buyerInvoiceData.buyerPhoneNumber = buyerInvoiceDetailsValidationResponse.result.buyerPhoneNumber
                buyerInvoiceData.buyerEmailId = buyerInvoiceDetailsValidationResponse.result.buyerEmailId

                let confirmMessage = 'Are you sure you want to create preview invoice?'
                if (isLogisticsDeliveryAtActuals) {
                    if (!totalBuyerPOLogisticAmount && logisticAmount == 0) {
                        return dispatch(raiseToast({ severity: 'warn', detail: `Logistics on Actual was selected. Please enter logistics amount atleast 1 rupee`, life: 3000 }))
                    } else {
                        confirmMessage = "Logistics on Actual was selected, please ensure correct logistics are entered above.\n" + confirmMessage
                        if (logisticAmount < totalBuyerPOLogisticAmount) {
                            confirmMessage = "Entered logistics amount is lower than PO logistics amount. \n" + confirmMessage
                        }
                    }
                } else {
                    if (totalBuyerPOLogisticAmount > 0 && logisticAmount == 0) {
                        confirmMessage = "BuyerPO logistic was there, do you want to continue without logistics."
                    }

                    if (logisticAmount > totalBuyerPOLogisticAmount) {
                        return dispatch(raiseToast({ severity: 'warn', detail: `Logistic amount should not greater than ${totalBuyerPOLogisticAmount}`, life: 3000 }))
                    }
                }
                console.log("replacementItems", replacementItems)
                let buyerInvoiceObj = { 
                    buyerInvoiceData, 
                    buyerInvoiceItems, 
                    dispatchNoteIds, 
                    dispatchNoteDocNo, 
                    dispatchNoteFileNo, 
                    allDispatchNoteItems, 
                    replacementItems,
                    groupingItemId
                }

                if (totalLogisticsBeforeTax > 0 && !buyerInvoiceData?.logisticsHSNCode){
                    dispatch(raiseToast({ severity: 'warn', detail: "Please Enter Logistics HSNCode", life: 3000 }))
                }else if(replacementItems.length === 0){
                    setVisibleConfirmPreviewInvoiceVisible(true)
                    setNewBuyerInvoiceData(buyerInvoiceObj)
                }
                else if (window.confirm(confirmMessage)) {
                    await createBuyerInvoice(buyerInvoiceObj)
                    // setIsLoading(true)
                    // let createInvoiceResponse = await insertBuyerInvoice({ 
                    //     buyerInvoiceData, 
                    //     buyerInvoiceItems, 
                    //     dispatchNoteIds, 
                    //     dispatchNoteDocNo, 
                    //     dispatchNoteFileNo, 
                    //     allDispatchNoteItems, 
                    //     replacementItems,
                    //     renamedItems,
                    //     groupingItemId
                    //     //deliveryChallan: newDeliveryChallan 
                    // })

                    // if (createInvoiceResponse.failure) {
                    //     setIsLoading(false)
                    //     dispatch(raiseToast({ severity: 'error', detail: createInvoiceResponse.data.error, life: 3000 }))
                    // } else {
                    //     setIsLoading(false)
                    //     props.setIsCreateInvoiceModalVisible(false)
                        
                    //     dispatch(fetchBuyerPOs({ ...searchParams }))
                    //     dispatch(raiseToast({ severity: 'success', detail: "Invoice Created Successfully", life: 3000 }))
                    //     if (createInvoiceResponse?.data) {
                    //         window.open(`/buyerInvoice/${createInvoiceResponse?.data?.buyerInvoice?.buyerInvoiceId}`, '_blank')
                    //     }
                    // }
                }
            }
        }
    }

    const createBuyerInvoice = async(buyerInvoiceObj) => {
        setIsLoading(true)
        let createInvoiceResponse = await insertBuyerInvoice({...buyerInvoiceObj})
        console.log("createInvoice-response", createInvoiceResponse)
        if (createInvoiceResponse.failure) {
            setIsLoading(false)
            dispatch(raiseToast({ severity: 'error', detail: createInvoiceResponse.data.error, life: 3000 }))
        } else {
            setIsLoading(false)
            props.setIsCreateInvoiceModalVisible(false)
            setVisibleConfirmPreviewInvoiceVisible(false)
            setVisibleRenameBuyerInvoiceItems(false)

            let updatedSearchParams = { ...searchParams }
            if (updatedSearchParams.searchBy !== "all") {
                updatedSearchParams[updatedSearchParams.searchBy] = updatedSearchParams.searchText.trim()
            }

            dispatch(fetchBuyerPOs({ ...updatedSearchParams }))
            dispatch(raiseToast({ severity: 'success', detail: "Invoice Created Successfully", life: 3000 }))
            if (createInvoiceResponse?.data) {
                window.open(`/buyerInvoice/${createInvoiceResponse?.data?.buyerInvoice?.buyerInvoiceId}`, '_blank')
            }
        }
    }

    const handleShippingAddress = (shipAddrId) => {
        if (shipAddrId) {
            setSelectedBuyerShipAddrId(shipAddrId)
        } else {
            setSelectedBuyerShipAddrId(null)
        }
    }

    const handleBillingAddress = (billAddrId) => {
        if (billAddrId) {
            setSelectedBuyerBillAddrId(billAddrId)
        } else {
            setSelectedBuyerBillAddrId(null)
        }
    }

    const handleEmailChange = (event) => {
        setBuyerEmailId(event.target.value)
    }

    const handleBuyerPhoneNumberChange = (event) => {
        setBuyerPhoneNumber(event.target.value)
    }

    const handleBuyerPODateChange = (event) => {
        setBuyerPODate(event.target.value)
    }

    const handleOnclickShowReplaceItems = () => {
        if (!isReplaceItems) {
            setReplaceBuyerReqItems(JSON.parse(JSON.stringify(buyerReqWiseDispatchNoteItems)))
        } else {
            setSelectedReplaceBuyerReqItemIds([])
            setReplaceBuyerReqItems([])
        }
        setIsReplaceItems(!isReplaceItems)
    }

    const searchLogisticsHSNs = (event) => {
        const relatedLogisticHSNs = logisticHSNOptions.filter(eachHSN => eachHSN.label.toLowerCase().startsWith(event.query.trim().toLowerCase()))
        if (relatedLogisticHSNs.length > 0) {
            setSearchedLogisticsHSNCodes(relatedLogisticHSNs)
        }
    }

    const handleLogisticHSNChange = (e) => {
        setLogisticsHSNCode(e.target.value)
    }

    const handleBuyerReqReplacementItems = () => {
        let relatedBuyerReqItems = replaceBuyerReqItems.filter(eachBuyerReqItem => selectedReplaceBuyerReqItemIds.includes(eachBuyerReqItem.buyerReqItemId))
        setSelectedReplaceBuyerReqItems(relatedBuyerReqItems)
        setIsReplaceItemsVisible(true)
    }

    const handleReplacementItem = (replacementItem) => {

        let replacementBuyerReqObj = {
            buyerReqItemId: uuidv4(),
            // productName: replacementItem.productName,
            // productSpecification: replacementItem.productSpecification,
            companyProdName: replacementItem.companyProdName,
            companyProdSpec: replacementItem.companyProdSpec,
            GSTRate: replacementItem.GSTRate,
            HSNCode: replacementItem.HSNCode,
            createdBy: userId,
            qty: replacementItem.qty,
            UOM: replacementItem.UOM,
            totalQty: replacementItem.qty,
            unitPrice: replacementItem.unitPrice,
            updatedBy: userId,
            isReplaced: true,
            //totalAmount: null,
            totalAmount: round(parseFloat(replacementItem.qty * replacementItem.unitPrice), 4),
            persistent: false,
            replacedBuyerReqItems: [...selectedReplaceBuyerReqItems]
        }

        let relatedBuyerReqWiseDispatchNoteItems = buyerReqWiseDispatchNoteItems.map(eachDispatchNoteItem => {
            let relatedReplaceBuyerReqItem = selectedReplaceBuyerReqItems.find(eachReplaceBuyerReqItem => eachReplaceBuyerReqItem.buyerReqItemId === eachDispatchNoteItem.buyerReqItemId)
            if(relatedReplaceBuyerReqItem){
                eachDispatchNoteItem.qty = eachDispatchNoteItem.qty - relatedReplaceBuyerReqItem.qty
                eachDispatchNoteItem.totalAmount = round(eachDispatchNoteItem.qty * eachDispatchNoteItem.unitPrice, DECIMAL_LIMIT)
                if(eachDispatchNoteItem.qty === 0){
                    return null
                }
            }
            return eachDispatchNoteItem
        })
        
        let uniqeBuyerReqWiseDispatchNoteItems = relatedBuyerReqWiseDispatchNoteItems.filter(eachDispatchNoteItem => eachDispatchNoteItem !== null)
        
        setSelectedReplaceBuyerReqItems([])
        setBuyerReqWiseDispatchNoteItems([...uniqeBuyerReqWiseDispatchNoteItems, replacementBuyerReqObj])
        setIsReplaceItems(!isReplaceItems)
        setIsReplaceItemsVisible(false)
        setSelectedReplaceBuyerReqItemIds([])
    }

    const handleLogisticAmountChange = (event) => {
        let logisticAmountValue = event.target.value
        if(event.target.value === ""){
            logisticAmountValue = 0
        }
        if(logisticAmountValue > totalBuyerPOLogisticAmount){
            logisticAmountValue = 0
        }
        setLogisticAmount(logisticAmountValue)
        //setLogisticAmount(event.target.value)
    }

    const searchBuyerCompanyUsers = (event) => {
        const relatedBuyerCompanyUsers = buyerCompanyUsers.filter(eachUser => eachUser.fullName.toLowerCase().startsWith(event.query.trim().toLowerCase()))
        if(relatedBuyerCompanyUsers.length > 0){
            setSearchedBuyerCompanyUsers(relatedBuyerCompanyUsers)
        }else{
            setSearchedBuyerCompanyUsers(["This is empty"])
        }
    }

    const handleRecipientUserChange = (event) => {
        setRecipientUser(event.target.value)
    }

    const handleVehicleNumberChange = (event) => {
        setVehicleNo(event.target.value?.toUpperCase())
    }

    const handleOnClickRenameProducts = () => {
        setVisibleRenameBuyerInvoiceItems(true)
    }

    const handleSubmitCreateInvoiceWithRenamedInvoiceItems = async(isGenerateInvoice, renamedItems) => {
        await createBuyerInvoice({...newBuyerInvoiceData, renamedItems})
    }
    
    let displayLabel = false

    let totalBuyerPOLogisticAmountText = totalBuyerPOLogisticAmount
    if(isLogisticsDeliveryAtActuals){
        totalBuyerPOLogisticAmountText = totalBuyerPOLogisticAmount ? `${totalBuyerPOLogisticAmount} + On Actuals` : "On Actuals"
    }

    const selectedInvoiceDispatchNotes = selectedBuyerPODispatchNotes.filter(eachDispatchNote => selectedInvoiceDispatchNotesIds.includes(eachDispatchNote.dispatchNoteId))
    let requiredGroupItemsMap = reqWiseGroupedDispatchNoteItems
    if (selectedInvoiceDispatchNotes.length && selectedInvoiceDispatchNotes[0].itemsGroupedBy === "buyerPOItemId"){
        requiredGroupItemsMap = poItemWiseGroupedDispatchNoteItemsMap
    }

    let itemsGroupedBy = null
    if(selectedInvoiceDispatchNotes.length){
        itemsGroupedBy = selectedInvoiceDispatchNotes[0].itemsGroupedBy
        if(!itemsGroupedBy){
            itemsGroupedBy = "buyerReqItemId"
        }
    }

    let dispatchNotesExistWithGroupedByBuyerPOItemId = selectedBuyerPODispatchNotes.find(eachDispatchNote => eachDispatchNote.itemsGroupedBy === "buyerPOItemId")

    return (
        <div className="p-card py-2">
            <div className="flex space-between mb-2 mt-1" style={{ width: "100%", flex: 1, justifyContent: "space-between" }}>
                <div className='flex flex-row'>
                    <CheckboxField checked={selectedBuyerPODispatchNotes.length === selectedInvoiceDispatchNotesIds.length} onChange={(event) => buyerCompany.tags?.groupBuyerInvoiceItemsBy === "buyerPOItemId" ? handleAllDispatchCheckBoxBuyerPOItemLevel(event) : handleAllDispatchCheckBox(event)} disabled={isReplaceItems || dispatchNotesExistWithGroupedByBuyerPOItemId} />
                    <label htmlFor="selectAllVendor" className="ml-2">Select All</label>
                </div>
            </div>
            {
                selectedBuyerPODispatchNotes?.map(dispatchNote => {
                    let relatedDispatchNoteItems = dispatchNoteItems.filter(eachDispatchNoteItem => eachDispatchNoteItem.dispatchNoteId === dispatchNote.dispatchNoteId)
                    return (
                        <DispatchNote
                            dispatchNote={dispatchNote}
                            groupBuyerInvoiceItemsBy={dispatchNote.itemsGroupedBy || "buyerReqItemId"}
                            handleAllDispatchCheckBox={handleAllDispatchCheckBox}
                            handleSelectDispatchCheckBox={handleSelectDispatchCheckBox}
                            handleAllDispatchCheckBoxBuyerPOItemLevel={handleAllDispatchCheckBoxBuyerPOItemLevel}
                            handleSelectDispatchCheckBoxBuyerPOItemLevel={handleSelectDispatchCheckBoxBuyerPOItemLevel}
                            selectedInvoiceDispatchNotesIds={selectedInvoiceDispatchNotesIds}
                            selectedInvoiceDispatchNotes={selectedInvoiceDispatchNotes}
                            dispatchNoteItems={relatedDispatchNoteItems}
                            reqWiseGroupedDispatchNoteItems={reqWiseGroupedDispatchNoteItems}
                            isReplaceItems={isReplaceItems}
                            handleDeleteDispatchNote={props.handleDeleteDispatchNote}
                            selectedBuyerPOs={selectedBuyerPOs}
                        />
                    )
                })
            }
            {
                Object.keys(requiredGroupItemsMap).length > 0 &&
                <>
                    <div className='flex'>
                        <h4 className="ml-2 mr-3 mb-2">Dispatch Note Items</h4>
                        <div>
                            { itemsGroupedBy !== "buyerPOItemId" ? 
                                <a style={{ cursor: 'pointer' }} onClick={() => handleOnclickShowReplaceItems()}>
                                    {isReplaceItems ? "Click here to buyer invoice items" : "Click here to replace items"}
                                </a> : ""
                            }
                        </div>
                    </div>
                    {
                        isReplaceItems ?
                        <>
                            <Button className="small-btn mb-2" disabled={selectedReplaceBuyerReqItemIds.length === 0} label="Replace" onClick={() => handleBuyerReqReplacementItems()} />
                            <div className="p-card col-12 mb-2 xl:col-12 m-0" style={{ padding: 0 }}>
                                <div className="" style={{ paddingLeft: 15, paddingRight: 15 }} >
                                    {
                                        replaceBuyerReqItems?.map((eachBuyerReqItem, index) => {

                                            if (index === 0 && !displayLabel) {
                                                displayLabel = true
                                            }

                                            return (
                                                <ReplaceBuyerReqItems
                                                    buyerReqItem={eachBuyerReqItem}
                                                    displayLabel={displayLabel}
                                                    selectedReplaceBuyerReqItemIds={selectedReplaceBuyerReqItemIds}
                                                    setSelectedInvoiceDispatchNotesIds={setSelectedReplaceBuyerReqItemIds}
                                                    replaceBuyerReqItems={replaceBuyerReqItems}
                                                    setReplaceBuyerReqItems={setReplaceBuyerReqItems}
                                                />
                                            )
                                        }
                                        )}
                                </div>
                            </div>
                            </>
                            :
                            <div className="p-card col-12 mb-2 xl:col-12 m-0" style={{ padding: 0 }} >
                                <div className="" style={{ paddingLeft: 15, paddingRight: 15 }}>
                                    <div>
                                        <div style={{ height: 6 }} ></div>
                                        <div className="mb-1 dispatch-note-items py-1" id={""}>
                                            <div>
                                                <table className="custom-table" style={{ width: "100%" }}>
                                                    <thead >
                                                        <tr className="custom-table-tr">
                                                            <th className="custom-th" >MATERIAL ID</th>
                                                            <th className="custom-th" >PRODUCT DETAILS</th>
                                                            <th className="custom-th" >UOM</th>
                                                            <th className="custom-th" >UNIT PRICE</th>
                                                            <th className="custom-th" >TOTAL QUANTITY</th>
                                                            <th className="custom-th" >TOTAL AMOUNT</th>
                                                            <th className="custom-th" >DELETE</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                                        {
                                                            selectedInvoiceDispatchNotes[0]?.itemsGroupedBy === "buyerPOItemId" ? 
                                                            buyerPOItemWiseDispatchNoteItems?.map((eachBuyerPOItem, index) => {
                                                                return (
                                                                    <DispatchNoteItems
                                                                        buyerPOItem={eachBuyerPOItem}
                                                                        groupBuyerInvoiceItemsBy={selectedInvoiceDispatchNotes[0]?.itemsGroupedBy}
                                                                        buyerPOItemWiseDispatchNoteItems={buyerPOItemWiseDispatchNoteItems}
                                                                        setBuyerPOItemWiseDispatchNoteItems={setBuyerPOItemWiseDispatchNoteItems}
                                                                    />
                                                                )
                                                            })
                                                            :
                                                            buyerReqWiseDispatchNoteItems?.map((eachBuyerReqItem, index) => {
                                                                return (
                                                                    <DispatchNoteItems
                                                                        buyerReqItem={eachBuyerReqItem}
                                                                        groupBuyerInvoiceItemsBy={selectedInvoiceDispatchNotes[0]?.itemsGroupedBy}
                                                                        buyerReqWiseDispatchNoteItems={buyerReqWiseDispatchNoteItems}
                                                                        setBuyerReqWiseDispatchNoteItems={setBuyerReqWiseDispatchNoteItems}
                                                                    />
                                                                )
                                                            })
                                                        }
                                                        {/* {
                                                            buyerReqWiseDispatchNoteItems?.map((eachBuyerReqItem, index) => {
                                                                return (
                                                                    <DispatchNoteItems
                                                                        buyerReqItem={eachBuyerReqItem}
                                                                        buyerReqWiseDispatchNoteItems={buyerReqWiseDispatchNoteItems}
                                                                        setBuyerReqWiseDispatchNoteItems={setBuyerReqWiseDispatchNoteItems}
                                                                    />
                                                                )
                                                            })
                                                        } */}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='hr-line'></div>
                                </div>
                            </div>
                    }
                </>
            }
            <div className="py-1">
                <div className="hr-line"></div>
                <h5 className="text-600 my-2">Shipping Address</h5>
                <ShippingAddressCards shippingAddresses={buyerCompanyBranchShipAddrs} selectedAddressId={selectedBuyerShipAddrId} handleShippingAddress={handleShippingAddress} />
                <div className="hr-line"></div>
                <h5 className="text-600 my-2">Billing Address</h5>
                <BillingAddressCards billingAddresses={buyerCompanyBillAddrs} selectedAddressId={selectedBuyerBillAddrId} handleBillingAddress={handleBillingAddress} />
                <div className="hr-line mb-2"></div>
            </div>
            <div className="grid">
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <TextInputField name='buyerEmailId' labelText='Buyer Email' value={buyerEmailId} onChange={(e) => handleEmailChange(e)} errorMessage={formErrors.buyerEmailId} />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <TextInputField name='buyerPhoneNumber' labelText='Buyer Phone Number' value={buyerPhoneNumber} keyfilter='pnum' onChange={(e) => handleBuyerPhoneNumberChange(e)} errorMessage={formErrors.buyerPhoneNumber} />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <TextInputField name='buyerPONumbers' labelText='Buyer PO Number' value={buyerPONumbers.join(',')} disabled />
                </div>
                <div className="flex flex-column mb-2 lg:col-2 lg:mb-0" style={{ width: "20%" }}>
                    <CalendarField name="buyerPODate" labelText="Buyer PO Date" placeholder="Buyer PO Date" value={buyerPODate} onChange={(e) => handleBuyerPODateChange(e)} />
                </div>
                <div className="flex flex-column mb-2 lg:col-2 lg:mb-0">
                    <DropDownField name="supplyType" labelText="Supply Type" options={companySupplyTypes} optionLabel="supplyType" optionValue="supplyTypeId" value={supplyType} onChange={(event) => setSupplyType(event.target.value)} />
                </div>
                <div className="flex flex-column mb-2 lg:col-2 lg:mb-0">
                    <TextInputField name="vehicleNo" labelText="Vehicle No" placeholder="Vehicle No" value={vehicleNo} maxLength={15} onChange={e => handleVehicleNumberChange(e)} />
                </div>
                <div className="flex flex-column mb-2 lg:col-2 lg:mb-0">
                    <TextInputField name="Logistic Amount" labelText="Logistic Amount" keyfilter="pnum" value={logisticAmount} onChange={(event) => handleLogisticAmountChange(event)} disabled/>
                </div>
                <div className="flex flex-column mb-2 lg:col-2 lg:mb-0">
                    {/* <TextInputField name="logisticsHSNCode" labelText="Logistic HSN" keyfilter="pnum" value={logisticsHSNCode} onChange={(event) => handleLogisticHSNChange(event)} /> */}
                    <AutoCompleteField name="logisticsHSNCode" labelText="Logistic HSN" field="label" placeholder="Select HSN" value={logisticsHSNCode} suggestions={searchedLogisticsHSNCodes} searchMethod={searchLogisticsHSNs} onChange={(event) => handleLogisticHSNChange(event)} dropdown forceSelection />
                </div>
                <div className="flex mb-2 align-items-center lg:col-4 lg:mb-0">
                    <i className="pi pi-info-circle company-group-eye-icon mr-1 ml-2"></i>
                    <p>BuyerPO total logistic amount: <span style={{ color: "red" }}>{totalBuyerPOLogisticAmountText}</span></p>
                </div>
            </div>
            <div className='grid'>
                <div className="flex flex-column col-12 lg:col-2 lg:mb-0">
                    <DropDownField name="TCSRate" labelText="TCS Rate(%)" options={TCSRateOptions} optionLabel="label" optionValue="value" value={TCSRate} onChange={(e) => setTCSRate(e.target.value)} permissions={[264]} />
                </div>
                {
                    showBiofuelActivityType ?
                        <div className="flex flex-column col-12 lg:col-2 lg:mb-0">
                            <DropDownField name="biofuelActivityType" labelText="Biofuel Activity Type" options={biofuelActivityTypes} optionLabel="label" optionValue="value" value={biofuelActivityType} onChange={(e) => setBiofuelActivityType(e.target.value)} />
                        </div> : null
                }
            </div>
            {
                showRecipientUserInput ?
                    <div className="grid mt-1">
                        <div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0">
                            <label htmlFor="recipientUserId" style={{ fontSize: "12px", marginBottom: "3px" }}>
                                Recipient User
                                <Tooltip target=".custom-target-icon" position="right" content="If user not found plase add the user in company and refresh the page" />
                                <i className="pi pi-info-circle custom-target-icon ml-2"></i>
                            </label>
                            <AutoCompleteField name="recipientUserId" suggestions={searchedBuyerCompanyUsers} field="fullName" value={recipientUser} onChange={e => handleRecipientUserChange(e)} searchMethod={searchBuyerCompanyUsers} dropdown forceSelection />
                        </div>
                        <div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0">
                            <TextInputField name="recipientUserPhoneNo" labelText="Recipient User Phone No" placeholder="" value={recipientUser?.phoneNumber} onChange={e => handleRecipientUserChange(e)} disabled />
                        </div>
                    </div>
                    :
                    <div className="mt-2 mb-2">
                        <span onClick={() => setShowRecipientUserInput(true)} style={{ cursor: "pointer" }}><i className='pi pi-plus-circle mr-1' style={{ color: '#00baaa' }} />Add Recipient User</span>
                    </div>
            }
            <div className=''>
                <CheckboxField name="suppliedToExporter" inputId="suppliedToExporter" label="Supplied to Exporter (0.1% GST Applicable)" checked={suppliedToExporter} onChange={(event) => { setSuppliedToExporter(event.target.checked) }} disabled={!buyerCompany?.tags?.isMerchantExporter} />
            </div>
            <div className='flex justify-content-end flex-row mt-4'>
                <Button className="small-btn" label="Create Preview Invoice" onClick={onSubmitCreateInvoice} />
            </div>
            <Dialog header="Replace Item" className='pi-punch-dialog' visible={isReplaceItemsVisible} style={{ width: '60vw', minHeight: '50vh', backgroundColor: '#f8f8f8' }} onHide={() => setIsReplaceItemsVisible(false)}>
                <ReplacementItems
                    selectedReplaceBuyerReqItems={selectedReplaceBuyerReqItems}
                    handleReplacementItem={handleReplacementItem}
                />
            </Dialog>
            <RenameBuyerInvoiceItems 
                visibleRenameBuyerInvoiceItems={visibleRenameBuyerInvoiceItems}
                setVisibleRenameBuyerInvoiceItems={setVisibleRenameBuyerInvoiceItems}
                buyerReqWiseDispatchNoteItems={buyerReqWiseDispatchNoteItems}
                buyerPOItemWiseDispatchNoteItems={buyerPOItemWiseDispatchNoteItems}
                itemsGroupedBy={itemsGroupedBy}
                handleSubmit={handleSubmitCreateInvoiceWithRenamedInvoiceItems}
            />
            <ConfirmDialog
                visible={visibleConfirmPreviewInvoiceVisible}
                onHide={() => setVisibleConfirmPreviewInvoiceVisible(false)}
                header={"Please select option"}
                footer={
                    <div>
                        <Button
                            label="Only Create Preview Invoice"
                            onClick={()=>createBuyerInvoice(newBuyerInvoiceData)}
                            className="small-btn"
                            autoFocus
                            applyThrottle={true}
                        />
                        <Button
                            label="Rename Products"
                            onClick={()=>handleOnClickRenameProducts()}
                            className="small-btn"
                            style={{ backgroundColor: '#a1a1f7', border: "1px solid #a1a1f7" }}
                            autoFocus
                            applyThrottle={true}
                        />
                    </div>
                }
            />
            <Loading visible={isLoading} />
        </div>
    )
}

export default CreateInvoice;